import axios from "axios";



  export  const loginAuth = async (postData) => {
      try {

        const {data} = await axios.post(
          "/v1/admin/login",
          postData,
          {
    headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
          }
        );
        console.log('data', data)
         return data
        
      } catch (error) {
        throw error
  
      }
    };
     

    export const csrf = async() => {
      axios.defaults.withCredentials = true; 
      axios.defaults.withXSRFToken =true;
  const res = await axios.get('http://192.168.1.143:8000/sanctum/csrf-cookie');
  return res
};
